/*
  Murlong Cres — currency-aware free shipping.

  The theme's built-in free-shipping bar treats the threshold as a fixed number
  in whatever currency the customer browses in (so 3800 kr shows as "$3800").
  These two custom elements instead convert the shop-base threshold into the
  customer's presentment currency using Shopify.currency.rate, so the amount is
  correct in every market.

  Self-contained, so a Prestige theme update won't touch it.
*/
(function () {
  function rate() { try { return parseFloat(window.Shopify.currency.rate) || 1; } catch (e) { return 1; } }
  function activeCurrency() { try { return window.Shopify.currency.active; } catch (e) { return 'NOK'; } }
  function locale() { try { return window.Shopify.locale || 'en'; } catch (e) { return 'en'; } }

  function fmt(cents, currency) {
    var amount = cents / 100;
    try {
      // Norwegian home market reads "3 800 kr", not "NOK 3,800".
      if (currency === 'NOK') {
        return new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 }).format(amount) + ' kr';
      }
      return new Intl.NumberFormat(locale(), { style: 'currency', currency: currency, maximumFractionDigits: 0, currencyDisplay: 'narrowSymbol' }).format(amount);
    } catch (e) { return Math.round(amount) + ' ' + currency; }
  }

  // shop-base major units -> presentment cents
  function thresholdCents(el) {
    var base = parseFloat(el.getAttribute('base-threshold')) || 0;
    return Math.round(base * rate() * 100);
  }

  var MCFreeShippingBar = class extends HTMLElement {
    connectedCallback() {
      this._handler = this.render.bind(this);
      document.addEventListener('cart:change', this._handler);
      this.render();
    }
    disconnectedCallback() { document.removeEventListener('cart:change', this._handler); }
    render(evt) {
      var self = this;
      var thr = thresholdCents(this);
      var total = parseFloat(this.getAttribute('total-price'));
      if (isNaN(total) && evt && evt.detail && evt.detail.cart) total = evt.detail.cart.total_price;
      var draw = function (totalCents) {
        var cur = activeCurrency();
        var remaining = Math.max(0, thr - totalCents);
        var pct = thr > 0 ? Math.min(100, Math.round((totalCents / thr) * 100)) : 100;
        var msg;
        if (remaining <= 0) {
          msg = self.getAttribute('reached-message') || 'You are eligible for free shipping.';
        } else {
          msg = (self.getAttribute('unreached-message') || 'Spend {{ remaining_amount }} more and get free shipping!')
            .replace(/\{\{\s*remaining_amount\s*\}\}/g, fmt(remaining, cur));
        }
        self.innerHTML =
          '<p class="mc-fsb__msg">' + msg + '</p>' +
          '<span class="mc-fsb__track"><span class="mc-fsb__fill" style="width:' + pct + '%"></span></span>';
      };
      if (isNaN(total)) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { draw(c.total_price); }).catch(function () { draw(0); });
      } else {
        draw(total);
      }
    }
  };

  // Announcement-bar amount: converts the shop-base free-shipping threshold into
  // the customer's currency and drops it inline (e.g. "Complimentary shipping over $409").
  var MCShipAmount = class extends HTMLElement {
    connectedCallback() {
      this.textContent = fmt(thresholdCents(this), activeCurrency());
    }
  };

  var MCFreeShippingNote = class extends HTMLElement {
    connectedCallback() {
      var span = this.querySelector('.mc-fsn__text');
      if (!span) return;
      var label = this.getAttribute('label') || 'Free shipping on orders over {{ amount }}';
      span.textContent = label.replace(/\{\{\s*amount\s*\}\}/g, fmt(thresholdCents(this), activeCurrency()));
    }
  };

  // Real review proof, read from the page's JSON-LD aggregateRating (Trustoo).
  // Hides itself if the product has no reviews, so it never shows a fake number.
  var MCReviewProof = class extends HTMLElement {
    connectedCallback() {
      var r = this.findRating();
      var span = this.querySelector('.mc-review-proof__text');
      if (!r || !r.count || !span) { this.style.display = 'none'; return; }
      span.innerHTML = '<span class="mc-review-proof__stars">★★★★★</span> ' +
        r.value + ' · ' + r.count + ' reviews';
    }
    findRating() {
      var nodes = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < nodes.length; i++) {
        try { var found = dig(JSON.parse(nodes[i].textContent)); if (found) return found; } catch (e) {}
      }
      return null;
      function dig(o) {
        if (!o || typeof o !== 'object') return null;
        if (o.aggregateRating) return { value: o.aggregateRating.ratingValue, count: o.aggregateRating.reviewCount };
        for (var k in o) { var r = dig(o[k]); if (r) return r; }
        return null;
      }
    }
  };

  if (!window.customElements.get('mc-ship-amount')) window.customElements.define('mc-ship-amount', MCShipAmount);
  if (!window.customElements.get('mc-free-shipping-bar')) window.customElements.define('mc-free-shipping-bar', MCFreeShippingBar);
  if (!window.customElements.get('mc-free-shipping-note')) window.customElements.define('mc-free-shipping-note', MCFreeShippingNote);
  if (!window.customElements.get('mc-review-proof')) window.customElements.define('mc-review-proof', MCReviewProof);
})();
